export const validateRequiredFields = (obj, requiredKeys = []) => {
  //  eg: validateRequiredFields(obj, ["required field"."required field"]);

  const isEmpty = (val) =>
    val === "" ||
    val === null ||
    val === undefined ||
    (typeof val === "number" && Number.isNaN(val));

  const missingKeys = requiredKeys.filter((key) => isEmpty(obj[key]));

  return {
    isValid: missingKeys.length === 0,
    missingKeys,
  };
};
